import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import BallotIcon from '@mui/icons-material/Ballot';
import DescriptionIcon from '@mui/icons-material/Description';

import { useTabPages } from '@ts-core/hooks/ui';

import MediaPage from 'modules/media/pages/MediaPage';
import DocumentsPage from 'modules/documents/pages/DocumentsPage';
import ExercisesPage from 'modules/exercises/pages/ExercisesPage';

export default function useSubjectTabPages() {
  const intl = useIntl();

  const pages = useMemo(() => {
    const tabs = [
      {
        Component: ExercisesPage,
        tab: {
          label: intl.formatMessage({
            id: 'tab.exercises',
            defaultMessage: 'Ejercicios',
          }),
          slug: 'exercises',
          icon: <BallotIcon />,
        },
      },
    ];

    tabs.push({
      Component: MediaPage,
      tab: {
        label: intl.formatMessage({
          id: 'tab.videos',
          defaultMessage: 'Videos',
        }),
        slug: 'media',
        icon: <OndemandVideoIcon />,
      },
    });

    tabs.push({
      Component: DocumentsPage,
      tab: {
        label: intl.formatMessage({
          id: 'tab.documents',
          defaultMessage: 'Documentos',
        }),
        slug: 'documents',
        icon: <DescriptionIcon />,
      },
    });

    return tabs;
  }, [intl]);

  return useTabPages({ pages, slugParam: 'tab' });
}
